<div
    *ngIf="item?.layoutType === 'collections-banner-v3'"
    class="common-layout-container-desktop"
    ngClass.xs="common-layout-container-mobile"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="sharedLayoutsService.getStyles(item?.layoutContent?.padding)"
>
    <div
        class="title-row"
        fxLayoutAlign="space-between end"
        *ngIf="
            item?.layoutContent?.title?.text ||
            item?.layoutContent?.button?.title?.text
        "
        [ngStyle.xs]="{ paddingRight: '16px' }"
    >
        <h1
            *ngIf="item?.layoutContent?.title?.text"
            class="layout-heading"
            [style]="{ color: item?.layoutContent?.title?.color }"
            >{{ item?.layoutContent?.title?.text }}</h1
        >
        <a
            *ngIf="item?.layoutContent?.button?.title?.text"
            class="view-all-button"
            [routerLink]="[item?.layoutContent?.button?.link | pageIdFromLink]"
            [queryParams]="
                item?.layoutContent?.button?.link | queryParamFromLink
            "
            [attr.aria-label]="
                item?.layoutContent?.button?.title?.text || 'banner-link'
            "
            [style]="{ color: item?.layoutContent?.button?.title?.color }"
            >{{ item?.layoutContent?.button?.title?.text }}</a
        >
    </div>

    <app-custom-scrollbar
        scrollbarClass="hp-custom-scrollbar"
        scrollContainerSelector=".cards-row"
    >
        <div
            class="cards-row"
            ngClass.xs="cards-row-mobile"
            fxLayout="row"
            fxLayoutGap.gt-xs="25px"
            fxLayoutAlign.gt-xs="center stretch"
            *ngIf="item?.layoutContent?.slider?.length > 0"
            [ngStyle.xs]="{ display: 'flex', overflowX: 'auto', gap: '16px' }"
        >
            <div
                class="card"
                ngClass.xs="card__mobile"
                *ngFor="let card of item?.layoutContent?.slider"
                [ngStyle.xs]="{
                    flex: '0 0 80.222%',
                    margin: '0 0 16px 0'
                }"
            >
                <a
                    *ngIf="card?.banner?.image"
                    [routerLink]="[card?.banner?.link | pageIdFromLink]"
                    [queryParams]="card?.banner?.link | queryParamFromLink"
                    [attr.aria-label]="card?.title?.text || 'banner-link'"
                    [style]="{
                        cursor:
                            card?.banner?.link && card?.banner?.link !== ''
                                ? 'pointer'
                                : 'auto'
                    }"
                    [ngStyle.xs]="{
                        pointerEvents:
                            card?.banner?.link && card?.banner?.link !== ''
                                ? 'auto'
                                : 'none'
                    }"
                >
                    <img
                        *ngIf="card?.banner?.image"
                        [src]="card?.banner?.image"
                        alt="{{ card.title?.text }}"
                        class="image"
                        [ngClass]="{ 'image-banner-shimmer': showShimmer }"
                    />
                    <div
                        *ngIf="
                            card?.title?.text ||
                            card?.subtitle?.text ||
                            card?.subtextV2?.text ||
                            card.icon
                        "
                        class="card-title"
                        ngClass.xs="card-title-mobile"
                        [ngStyle]="{
                            'align-items':
                                !card?.subtitle?.text && !card?.subtextV2?.text
                                    ? 'center'
                                    : 'end'
                        }"
                    >
                        <div>
                            <h1
                                *ngIf="card?.title?.text"
                                class="layout-title"
                                [style]="{
                                    color: card?.title?.color,
                                    margin: !!card?.subtitle?.text
                                        ? '0 0 4px 0'
                                        : !!card?.subtextV2?.text
                                        ? '0 0 20px 0'
                                        : '0'
                                }"
                                >{{ card.title?.text }}</h1
                            >
                            <p
                                *ngIf="card?.subtitle?.text"
                                class="layout-subtext"
                                [innerHTML]="card?.subtitle?.text | lineBreak"
                                [style]="{
                                    color: card?.subtitle?.color,
                                    margin: !!card?.subtextV2?.text
                                        ? '0 0 20px 0'
                                        : '0'
                                }"
                                >{{ card?.subtitle?.text }}</p
                            >
                            <p
                                *ngIf="card?.subtextV2?.text"
                                [style]="{ color: card?.subtextV2?.color }"
                                class="layout-subtext"
                                >{{ card?.subtextV2?.text }}</p
                            >
                        </div>
                        <img
                            *ngIf="card.icon"
                            [src]="card.icon"
                            alt="arrow-icon"
                            class="arrow-icon"
                        />
                    </div>
                </a>
            </div>
        </div>
    </app-custom-scrollbar>
</div>
